import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isChecking: false,

  result: [],
};

const authTempAuthNumberReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_TEMP_AUTH_NUMBER_REQUEST:
        return {
            ...state,
            result: [],
            isFetching: true,
        };

    case types.GET_TEMP_AUTH_NUMBER_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetching: false,
        };

    case types.GET_TEMP_AUTH_NUMBER_FAILURE:
        return {
            ...state,
            result: [],
            isFetching: false,
        };

    case types.CHECK_TEMP_AUTH_NUMBER_REQUEST:
        return {
            ...state,
            result: [],
            isChecking: true,
        };

    case types.CHECK_TEMP_AUTH_NUMBER_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isChecking: false,
        };

    case types.CHECK_TEMP_AUTH_NUMBER_FAILURE:
        return {
            ...state,
            result: [],
            isChecking: false,
        };

    default:
      return state;
  }
};

export default authTempAuthNumberReducer;
